import * as _ from 'lodash';
export var getStyleParamsWithDefaults = function (styleParams, getDefaultStyleParamsFunc) {
    var _a = getDefaultStyleParamsFunc(), defaults = _a.defaults, overrides = _a.overrides;
    return _.defaultsDeep(_.merge(_.cloneDeep(styleParams), overrides), defaults);
};
//# sourceMappingURL=getStyleParamsWithDefaults.js.map